import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of, Subject } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { GenericResponse } from 'src/app/api-interfaces';
import { AuthService } from 'src/app/auth/auth.service';
import { Identity } from '../identity.model';
import { IdentityService } from '../identity.service';
import { GenericRequestResponse, Request } from './request.model';


@Injectable({
  providedIn: 'root'
})
export class RequestService {
  requests = new BehaviorSubject<Array<Request>>(null);
  readonly requests$ = this.requests;
  totalRequests = new BehaviorSubject<number>(0);
  drafts = new BehaviorSubject<Array<Request>>(null);
  readonly drafts$ = this.drafts;
  draftToCompile = new BehaviorSubject<Request>(null);
  requestToComplete = new BehaviorSubject<Request>(null);
  isSpinning = new Subject<boolean>();
  readonly isSpinning$ = this.isSpinning.asObservable();

  allowedOperations = new Map<string, Array<string>>([
    ["GOVERNMENT", ["showCreateDraft", "showCancelDraft", "showCancelRequest", ]],
    ["MANAGEMENT", ["showCompileDraft", "showApproveRequest"]],
  ]);

  constructor(
    private authService: AuthService,
    private identityService: IdentityService,
  ) { }

  obtainAllowedOperations(): Array<string> {
    let allowedOperations = [];
    for (let identity of this.authService.getCurrentUser().identities) {
      const role = identity.role;
      if (role) {
        const operations: Array<string> = this.allowedOperations.get(role);
        allowedOperations.push(...operations);
      }
    }
    return allowedOperations;
  }

  hasStatusAllowed(): boolean {
    for (let identity of this.authService.getCurrentUser().identities) {
      const identityCasted = new Identity(identity);
      const role = identity.role;
      const status = identity.status;
      if (role && (identityCasted.isManagement() || identityCasted.isGovernment()) && status && status == "ISSUED") {
        return true;
      }
      continue
    }
    return false;
  }

  getRequests(
    pageIndex: number = 1, pageSize: number = 10, sortField: string | null = "id",
    sortOrder: string | null = "descending", filter: Array<{ key: string; value: string }> | null = null, searchField: string = "search", searchValue: string = "")
  {
    this.isSpinning.next(true);
    this.identityService.getRequests(pageIndex, pageSize, sortField, sortOrder, filter, searchField, searchValue).pipe(
      finalize( () => {this.isSpinning.next(false)})
    ).subscribe({
      next: (value: GenericResponse)=>{
        const result: GenericRequestResponse = value.result;
        this.totalRequests.next(result.count);
        const data: Array<Request> = result.data;
        this.requests.next(data);
      }
    });
  }

  getDrafts(
    pageIndex: number = 1, pageSize: number = 10, sortField: string | null = "id",
    sortOrder: string | null = "descending", filter: Array<{ key: string; value: string }> | null = null, searchField: string = "search", searchValue: string = "")
  {
    this.isSpinning.next(true);
    this.identityService.getDrafts(pageIndex, pageSize, sortField, sortOrder, filter, searchField, searchValue).pipe(
      finalize( () => {this.isSpinning.next(false)})
    ).subscribe({
      next: (value: GenericResponse)=>{
        const result: GenericRequestResponse = value.result;
        this.totalRequests.next(result.count);
        const data: Array<Request> = result.data;
        this.drafts.next(data);
      }
    });
  }

}
